import React from 'react';
import './SplitLoadDriverDetail.scss';
import { Row, Col } from 'react-bootstrap';
import TextContent from '../../_common/TextContent';
import AssignDriverModal from '../../ListItem/AssignDriver';
import { LoadStatusEnum } from '../../../types/LoadStatusEnum';

interface SplitLoadDriverDetailProps {
    secondaryDriver?: string | null;
    secondaryCarrier?: string | null;
    box?: string | null;
    secondaryTruck?: string | null;
    secondaryChassis?: string | null;
    lofa?: string | null;
    regionId: number;
    status?: string | null;
    jobId?: number | null | undefined;
    loadId: number;
    lofaId: number;
    proppantName: string;
    sandPO: string;
    secondaryDriverId: number;
    secondaryDriverStatus: string;
    driver?: string;
    jobName?: string;
    refetch: () => void;
}

const SplitLoadDriverDetail = ({
    secondaryDriver,
    secondaryCarrier,
    box,
    secondaryTruck,
    secondaryChassis,
    lofa,
    regionId,
    status,
    jobId,
    loadId,
    lofaId,
    proppantName,
    sandPO,
    secondaryDriverId,
    secondaryDriverStatus,
    driver,
    jobName,
    refetch,
}: SplitLoadDriverDetailProps): React.ReactElement => {
    return (
        <Col>
            <Row className="SplitLoadDriverDetail-Title">Split Load Driver Details</Row>
            <Row>
                <TextContent hasTopMargin title={'Driver: '} value={secondaryDriver || ''}></TextContent>
            </Row>
            <Row>
                <TextContent hasTopMargin title={'Carrier: '} value={secondaryCarrier || ''}></TextContent>
            </Row>
            <Row>
                <TextContent hasTopMargin title={'Box: '} value={box || ''}></TextContent>
            </Row>
            <Row>
                <TextContent hasTopMargin title={'Truck: '} value={secondaryTruck || ''}></TextContent>
            </Row>
            <Row>
                <TextContent hasTopMargin title={'Chassis: '} value={secondaryChassis || ''}></TextContent>
            </Row>
            <Row>
                {secondaryDriverStatus === 'Accepted' ? (
                    <div className="DriverDetail-StatusLabel">
                        <i className="material-icons complete-icon">check_circle_outline</i>
                        <span className="status-label">Accepted</span>
                    </div>
                ) : (
                    ''
                )}
                {secondaryDriverStatus === 'Rejected' ? (
                    <div className="DriverDetail-StatusLabel">
                        <i className="material-icons rejected-icon">highlight_off</i>
                        <span className="status-label">Rejected</span>
                    </div>
                ) : (
                    ''
                )}
                {secondaryDriverStatus === 'Pending' ? (
                    <div className="DriverDetail-StatusLabel">
                        <i className="material-icons pending-icon">restore</i>
                        <span className="status-label">Pending</span>
                    </div>
                ) : (
                    ''
                )}
            </Row>
            {(secondaryDriverId == 0 || secondaryDriverStatus === 'Rejected') &&
            status != LoadStatusEnum.DELIVERED &&
            status != LoadStatusEnum.COMPLETED ? (
                <AssignDriverModal
                    jobId={jobId}
                    proppantName={proppantName}
                    lofa={lofa || ''}
                    regionId={regionId}
                    loadId={loadId}
                    lofaId={lofaId || 0}
                    isFromLoads={false}
                    isSplitLoad={true}
                    sandPO={sandPO}
                    driverName={driver || ''}
                    jobName={jobName || ''}
                    refetch={refetch}
                />
            ) : (
                ''
            )}
        </Col>
    );
};

export default SplitLoadDriverDetail;
